export default __webpack_public_path__ + "static/media/promission-newTask.075ec437.png";